<template>
  <thead>
  <tr>
    <th v-for="(col, idx) in cols" :key="idx" :class="col.align"><strong>{{ $t(col.i18n) }}</strong></th>
  </tr>
  </thead>
</template>

<script>
  export default {
    name: "TableHead",
    props: ['cols'],
  }
</script>

<style scoped>
  thead {
    display: table-header-group;
    border-collapse: collapse;
  }

  tr {
    background-color: #D3E2F0;
  }

  th {
    text-align: center;
    padding: 2px 4px 2px 4px !important;
    color: #333;
    font-size: 12px;
    vertical-align: middle;
  }

  .left {
    text-align: left;
  }

  .center {
    text-align: center;
  }

  .right {
    text-align: right;
  }
</style>
